import PropTypes from 'prop-types';
import React, { memo } from 'react';
import * as ColorBar from './horizontal-color-bar-styles';

/**
 * Renders a horizontal bar with inner bars and labels. E.g.
 * [6------6 4----4 7-------7]. Inner bar width is automatically assigned based on value
 *
 * @param {object} props
 * @param {Array<object>} props.data format: [{
 *   label: string   ..label text
 *   color: string   ..color of the part of the bar represented by this data
 *   message: string ..appears in popup
 *   value: number   ..numerical value for this dataset. E.g.: if graph shows ages, age is the value
 * }]
 */
function HorizontalColorBarComponent({ data }) {
  const labels = data.map((item) => (
    <ColorBar.LabelWrapper key={item.label}>
      <ColorBar.LabelColorMarker color={item.color} />
      <span>{item.label}</span>
    </ColorBar.LabelWrapper>
  ));

  const innerBars = data.map((item, i) => (
    <ColorBar.Item
      key={`color-bar-${i}`}
      data-balloon-pos="down"
      aria-label={item.message}
      percentage={item.percentage}
      color={item.color}
      value={item.value}
    />
  ));

  return (
    <div>
      <ColorBar.LabelGroup
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {labels}
      </ColorBar.LabelGroup>
      <ColorBar.BarWrapper>{innerBars}</ColorBar.BarWrapper>
    </div>
  );
}

HorizontalColorBarComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export const HorizontalColorBar = memo(HorizontalColorBarComponent);
